import React from 'react';
import colors from '../../theme/colors';

/**
 * Admin control buttons for tree nodes
 * Only visible when in admin mode
 */
const AdminNodeButtons = ({ node, onEdit, onCreate, onDelete }) => {
  return (
    <>
      {/* Edit Button */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          if (onEdit) onEdit(node);
        }}
        style={{
          position: 'absolute',
          top: '35px',
          right: '-13px',
          background: colors.base.adminActive,
          border: 'none',
          color: 'white',
          width: '30px',
          height: '30px',
          borderRadius: '50%',
          cursor: 'pointer',
          fontSize: '0.7rem',
          fontWeight: 'bold',
          transition: 'all 0.2s ease',
          zIndex: 1001,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: colors.effects.shadow
        }}
        onMouseEnter={(e) => {
          e.target.style.background = '#c0392b';
          e.target.style.transform = 'scale(1.1)';
        }}
        onMouseLeave={(e) => {
          e.target.style.background = '#e74c3c';
          e.target.style.transform = 'scale(1)';
        }}
        title={`Modifier ${node.title}`}
      >
        ✏️
      </button>

      {/* Create Child Button */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          if (onCreate) onCreate(node);
        }}
        style={{
          position: 'absolute',
          top: '70px',
          right: '-13px',
          background: colors.base.success,
          border: 'none',
          color: 'white',
          width: '30px',
          height: '30px',
          borderRadius: '50%',
          cursor: 'pointer',
          fontSize: '0.7rem',
          fontWeight: 'bold',
          transition: 'all 0.2s ease',
          zIndex: 1001,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: colors.effects.shadow
        }}
        onMouseEnter={(e) => {
          e.target.style.background = '#229954';
          e.target.style.transform = 'scale(1.1)';
        }}
        onMouseLeave={(e) => {
          e.target.style.background = '#27ae60';
          e.target.style.transform = 'scale(1)';
        }}
        title={`Ajouter enfant à ${node.title}`}
      >
        +
      </button>

      {/* Delete Button */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          if (onDelete) onDelete(node);
        }}
        style={{
          position: 'absolute',
          top: '105px',
          right: '-13px',
          background: colors.base.adminActive,
          border: 'none',
          color: 'white',
          width: '30px',
          height: '30px',
          borderRadius: '50%',
          cursor: 'pointer',
          fontSize: '0.8rem',
          fontWeight: 'bold',
          transition: 'all 0.2s ease',
          zIndex: 1001,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: colors.effects.shadow
        }}
        onMouseEnter={(e) => {
          e.target.style.background = '#c0392b';
          e.target.style.transform = 'scale(1.1)';
        }}
        onMouseLeave={(e) => {
          e.target.style.background = '#e74c3c';
          e.target.style.transform = 'scale(1)';
        }}
        title={`Supprimer ${node.title}`}
      >
        ✖️
      </button>
    </>
  );
};

export default AdminNodeButtons;
